import { style } from '@vanilla-extract/css';
import { themeVars } from '@customerio/pluma-components/css/theme-tokens';

export const conditionText = style(
  {
    fontSize: themeVars['font-size']['xs'],
    flexGrow: 1,
  },
  'condition-card-text',
);

export const card = style(
  {
    backgroundColor: themeVars.color['surface-base-hover'],
    border: `${themeVars.border['width-0125']} solid ${themeVars.color['border-minimal']}`,
    borderRadius: themeVars.radius['4'],
  },
  'condition-card',
);
